import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-insurance-claim-edit',
  templateUrl: './insurance-claim-edit.component.html',
  styleUrls: ['./insurance-claim-edit.component.scss'],
  standalone: false,
})
export class InsuranceClaimEditComponent implements OnInit {
  insuranceClaimUniqueId: string;
  readonly insuranceClaimId = signal(0);

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.insuranceClaimUniqueId = this.route.snapshot.params['uniqueId'];
  }

  onInsuranceClaimIdFilled(insuranceClaimId: number) {
    this.insuranceClaimId.set(insuranceClaimId);
  }
}
